import React, { useRef, useEffect } from 'react';
import Loading from '../../assets/svg/react-icon.svg'
//import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';

// Receive darkMode prop for background color and exit control props
const Loader = ({ isExiting, onExitComplete, darkMode }) => { 
    const loaderRef = useRef(null);
    // const nucleusRef = useRef(null);
    // const orbitsRef = useRef(null);

    // GSAP Entrance and Looping remains the same
    // useGSAP(() => {
    //     const entranceTl = gsap.timeline();
    //     entranceTl.from(nucleusRef.current, { scale: 0, duration: 0.8, ease: "elastic.out(1, 0.5)" });
        
    //     gsap.utils.toArray('.orbit').forEach(orbit => {
    //         const length = orbit.getTotalLength();
    //         entranceTl.from(orbit, {
    //             strokeDasharray: length,
    //             strokeDashoffset: length,
    //             duration: 1,
    //             ease: "power2.inOut"
    //         }, "-=0.8");
    //     });
        
    //     gsap.to(orbitsRef.current, { rotation: 360, duration: 8, ease: 'none', repeat: -1 });
    //     gsap.to(nucleusRef.current, { scale: 1.1, duration: 1.5, ease: 'power1.inOut', repeat: -1, yoyo: true });

    // }, { scope: loaderRef });

    // GSAP Exit Animation Logic
    useEffect(() => {
        if (isExiting) {
            const exitTl = gsap.timeline({
                onComplete: onExitComplete, // Instantly unmounts the loader on completion
            });

            // gsap.killTweensOf([orbitsRef.current, nucleusRef.current]);

            exitTl
                // 1. Shrink and fade the icon
                .to(loaderRef.current.querySelector('img'), {
                    opacity: 0,
                    scale: 0.5,
                    duration: 0.39,
                    ease: 'power2.in'
                })
                // 2. Shrink the height of the entire loader component (the shutter)
                .to(loaderRef.current, {
                    height: 0, 
                    paddingTop: 0,
                    paddingBottom: 0,
                    duration: 0.4,
                    ease: 'power3.inOut', // Use inOut for a smoother pull
                }, "-=0.2"); 
        }
    }, [isExiting, onExitComplete]);


    // Determine background color based on darkMode prop
    const bgColor = darkMode === 'dark' ? 'bg-[#1e1e1e]' : 'bg-[#ff8b0a88]';

    return (
        // 💡 CRITICAL: Add the background color class to the loader container
        <div ref={loaderRef} className={`w-full h-full flex justify-center items-center ${bgColor}`}>
            <img className='h-24' src={Loading} alt="" />
            {/* INLINED SVG */}
            {/* <svg
                className='h-24'
                viewBox="-11.5 -10.23174 23 20.46348"
                xmlns="http://www.w3.org/2000/svg"
            >
            nothig to change
                <title>React Logo</title>
                <circle ref={nucleusRef} cx="0" cy="0" r="2.05" fill="#61dafb" />
                <g ref={orbitsRef} className="orbit-group" stroke="#61dafb" strokeWidth="1" fill="none">
                    <ellipse className="orbit" rx="11" ry="4.2" />
                    <ellipse className="orbit" rx="11" ry="4.2" transform="rotate(60)" />
                    <ellipse className="orbit" rx="11" ry="4.2" transform="rotate(120)" />
                </g>
            </svg> */}
        </div>
    );
}

export default Loader;
